import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteUserByEmail } from 'shared/services/delete-user.service';

export const useDeleteUser = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isTouched, setIsTouched] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  
  const navigate = useNavigate();

  const validateEmail = (email: string): boolean => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleEmailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setEmail(value);
    setErrorMessage('');
    
    if (isTouched) {
      if (!value.trim()) {
        setEmailError('El email es requerido');
      } else if (!validateEmail(value)) {
        setEmailError('Por favor, ingresa un email válido');
      } else {
        setEmailError('');
      }
    }
  };

  const handleEmailBlur = () => {
    setIsTouched(true);
    if (!email.trim()) {
      setEmailError('El email es requerido');
    } else if (!validateEmail(email)) {
      setEmailError('Por favor, ingresa un email válido');
    } else {
      setEmailError('');
    }
  };

  const handleDeleteClick = () => {
    if (!email.trim()) {
      setEmailError('El email es requerido');
      setIsTouched(true);
      return;
    }
    
    if (!validateEmail(email)) {
      setEmailError('Por favor, ingresa un email válido');
      setIsTouched(true);
      return;
    }
    
    setShowConfirmation(true);
  };

  const handleConfirmDelete = async () => {
    setIsLoading(true);
    setErrorMessage('');
    
    try {
      const response = await deleteUserByEmail(email);
      setSuccessMessage(response.message || 'Usuario eliminado exitosamente');
      setEmail('');
      setIsTouched(false);
      setEmailError('');
      
      // Redirect after 2 seconds
      setTimeout(() => {
        navigate('/settings');
      }, 2000);
    } catch (error: any) {
      setErrorMessage(error.message || 'Error al eliminar el usuario');
    } finally {
      setIsLoading(false);
      setShowConfirmation(false);
    }
  };

  const handleCancelDelete = () => {
    setShowConfirmation(false);
  };

  const handleBack = () => {
    navigate('/settings');
  };

  const isFormValid = email.trim() && validateEmail(email) && !emailError;

  return {
    email,
    emailError,
    isTouched,
    isLoading,
    showConfirmation,
    successMessage,
    errorMessage,
    isFormValid,
    handleEmailChange,
    handleEmailBlur,
    handleDeleteClick,
    handleConfirmDelete,
    handleCancelDelete,
    handleBack,
    setSuccessMessage,
    setErrorMessage,
  };
};
